import * as React from 'react';

function SvgWork(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M16 3.25v2.78h5.94v14.06H2V6.03h5.93V3.25H16zm3.94 8.63H4v6.21h15.94v-6.21zm0-3.85H4v2.35h15.94V8.03zM14.5 4.75H9.44v1.28h5.06V4.75z" />
    </svg>
  );
}

export default SvgWork;
